import React, { FC } from "react";

import { RoutesMenu } from "@Common";

const LoadingRouteFC: FC<{}> = () => {
  return <RoutesMenu />;
};

export const LoadingRoute = LoadingRouteFC;
